export const normalizePhone = (value, previousValue) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');

  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return `(${onlyNums}) `;
    }
    if (onlyNums.length === 6) {
      return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}-`;
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}`;
  }
  return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const normalizeSSN = (value, previousValue) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  // const separator = '-';
  const separator = '';

  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return onlyNums + separator;
    }
    if (onlyNums.length === 5) {
      return onlyNums.slice(0, 3) + separator + onlyNums.slice(3) + separator;
    }
  }

  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 5) {
    return onlyNums.slice(0, 3) + separator + onlyNums.slice(3);
  }
  return onlyNums.slice(0, 3) + separator + onlyNums.slice(3, 5) + separator + onlyNums.slice(5, 9);
};

export const normalizeCvv = (value) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');

  return onlyNums.slice(0, 4);
};

export const normalizeCardNumber = (value) => {
  if (!value) {
    return value;
  }

  if (value.indexOf('•') > -1) {
    return '';
  }
  const onlyNums = value.replace(/[^\d]/g, '').slice(0, 16);

  if (!onlyNums) {
    return onlyNums;
  }

  const parts = onlyNums.match(new RegExp('.{1,4}', 'g'));

  return parts.join(' ');
};

export const normalizeZipCode = (value) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');

  return onlyNums.slice(0, 5);
};

export const normalizeName = (max = 30) => {
  return value => {
    if (!value) {
      return value;
    }

    const onlyLetters = value.replace(/[^a-zA-Z\-\,\.\' ]/g, '');

    return onlyLetters.slice(0, max);
  };
};

export const normalizeTextWithMax = (max = 50) => {
  return value => {
    if (!value) {
      return value;
    }

    return value.slice(0, max);
  };
};

export const normalizeCity = (max = 50) => {
  return value => {
    if (!value) {
      return value;
    }

    const onlyAlpha = value.replace(/[^a-zA-Z]/g, '');

    return onlyAlpha.slice(0, max);
  };
};

export const removeNonDigits = string => string ? string.replace(/[^0-9]+/g, '') : string;



/** WEBPACK FOOTER **
 ** ./client/util/form/normalization.js
 **/